export const SHOW_DIALOG = '[dialog] SHOW_DIALOG';
export const SHOW_DIALOG_SUCCESS = '[dialog] SHOW_DIALOG_SUCCESS';